import { Controller } from "remult";

@Controller("association-team-methods")
export class AssociationTeamMethods {}
